import { Dispatch, SetStateAction } from 'react';
import { useIntl } from 'react-intl';

import { useTrackEventAmplitude } from '../../../../../../core/Tracking/Amplitude/Amplitude';
import { DestinationsMenu } from '../../../../../../resources/destinationsMenu/domain/types/destinationsMenu';
import { Container } from '../../../../Container/Container';
import { DestinationsContent } from '../../../Shared/Destinations/DestinationsContent';
import { PrimaryNavContextContinent, PrimaryNavValue } from '../../../types';
import { MobileSubNav } from '../MobileSubNav/MobileSubNav';
import { MobileView } from '../MobileView';

type Props = {
    contextContinent: PrimaryNavContextContinent | null;
    destinationsMenu: DestinationsMenu;
    setNavValue: Dispatch<SetStateAction<PrimaryNavValue>>;
};

export function DestinationsMobileView({ contextContinent, destinationsMenu, setNavValue }: Props) {
    const { formatMessage } = useIntl();
    const { trackEvent } = useTrackEventAmplitude();

    return (
        <>
            <MobileSubNav
                showPreviousButton={contextContinent ? true : false}
                onPrevious={() => {
                    setNavValue('HUB_DESTINATION');
                    trackEvent((ampli, defaultProperties) => {
                        ampli.primaryNavPreviousStepClicked({
                            ...defaultProperties,
                            block: 'primary_nav',
                        });
                    });
                }}
                setNavValue={setNavValue}
            />
            <MobileView title={formatMessage({ id: 'global.header.globalNav.destinations.label' })}>
                <Container>
                    <DestinationsContent
                        contextContinent={contextContinent}
                        destinationsMenu={destinationsMenu}
                    />
                </Container>
            </MobileView>
        </>
    );
}
